import { Component, ErrorInfo, PropsWithChildren, ReactNode } from 'react';
import { rage } from '~/rage';
import { StyledErrorPopup } from './ErrorBoundary.styled';

interface IErrorBoundaryStates {
	hasErrors: boolean;
}

class ErrorBoundary extends Component<PropsWithChildren, IErrorBoundaryStates> {
	constructor(props: PropsWithChildren) {
		super(props);
		this.state = { hasErrors: false };
	}

	static getDerivedStateFromError(): IErrorBoundaryStates {
		return { hasErrors: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		rage.notifications.showException(error);
		console.error(errorInfo);
	}

	render(): ReactNode {
		if (this.state.hasErrors) {
			return <StyledErrorPopup>Something went wrong...</StyledErrorPopup>;
		}

		return this.props.children;
	}
}

export { ErrorBoundary };
